import React from 'react'
import { Button, Divider } from 'semantic-ui-react'
import { FileCont } from './styled'

export const FileRow = (props) => {
  const { title='', attachments } = props
  return (
    <FileCont>
      <div className='titleFile'>{title}</div>
      <div className='fileItem'>
        {
          attachments.length > 0 ?
            attachments.map((item, i) => 
              <Button 
                type='button' 
                content={<div className='fileName'>{item.originalFilename}</div>} 
                icon='download' 
                labelPosition='left' 
                onClick={() => (window.location.href = item.urlPath)} />
            ) : 
            <div className='noFile'>There is no attachment.</div>
        }
        <Divider />
      </div>
    </FileCont>
  )
}